import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import "./dvrReports.scss";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import { Mutation } from "react-apollo";
import {
  ADD_DEALER_DVR_REPORT,
  ADD_DVR_COMMENT,
  ADD_DVR_OTHER_BRAND,
  ADD_DVR_OUR_BRAND,
  DELETE_DVR_OTHER_BRAND,
  DELETE_DVR_OUR_BRAND,
  DVR_REPORT_BY_ID,
  GET_MY_DEALERS_SALE,
  UPDATE_DVR_COMMENT,
  UPDATE_DVR_REPORT,
} from "../queries";
import useForm from "components/useForm";
import { toast } from "react-toastify";
import auth from "Auth";
import { useQuery } from "@apollo/client";
import { getAllDealerOptions } from "queries";
import { withRouter } from "react-router-dom";

function AddDvrReport({ editId, history }) {
  const { values, handleChange, resetState, setValues } = useForm(submitForm);
  function submitForm() {}
  const [reportEntries, setReportEntries] = useState([
    { dealer_dvr_report_id: "", description: "", qty: "" },
  ]);
  const [brandEntries, setBrandEntries] = useState([
    { dealer_dvr_report_id: "", description: "", qty: "" },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [errors, setErrors] = useState(false);
  const [comment, setComment] = useState("");
  const [commentId, setCommentId] = useState();

  const handleChanges = (event) => {
    const inputText = event.target.value;

    if (inputText.length <= 700) {
      setComment(inputText);
      setErrors(false);
    } else {
      setErrors(true);
    }
  };

  const completedAdd = (payload) => {
    setIsSubmit(false);
    resetState();
    setValues({});
    setReportEntries([{ dealer_dvr_report_id: "", description: "", qty: "" }]);
    setBrandEntries([{ dealer_dvr_report_id: "", description: "", qty: "" }]);
    if (editId) {
      toast("DVR report updated succesfully");
      history.push("/dealer-dvr-report");
    } else {
      toast("DVR report created succesfully");
    }
  };

  // const { data: profileData } = useQuery(getAllDealerOptions);
  const { data: profileData, loading: profileLoading } = useQuery(
    GET_MY_DEALERS_SALE,
    {
      notifyOnNetworkStatusChange: true,
      variables: editId
        ? { profile_id: values?.profiles?.profile_id }
        : { profile_id: auth.getSub() },
      fetchPolicy: "cache-and-network",
    }
  );

  const addReportEntry = () => {
    const newEntry = {
      dealer_dvr_report_id: "",
      description: "",
      qty: "",
    };
    setReportEntries([...reportEntries, newEntry]);
  };

  const addBrandEntry = () => {
    const newEntry = {
      dealer_dvr_report_id: "",
      description: "",
      qty: "",
    };
    setBrandEntries([...brandEntries, newEntry]);
  };

  const handleReportEntryChange = (index, field, value) => {
    const updatedEntries = [...reportEntries];
    updatedEntries[index][field] = value;
    setReportEntries(updatedEntries);
  };

  const handleBrandChange = (index, field, value) => {
    const updatedEntries = [...brandEntries];
    updatedEntries[index][field] = value;
    setBrandEntries(updatedEntries);
  };

  const validateEntries = () => {
    let isValid = true;

    reportEntries.forEach((entry) => {
      if (
        (entry.description && !entry.qty) ||
        (!entry.description && entry.qty)
      ) {
        isValid = false;
      }
    });

    brandEntries.forEach((entry) => {
      if (
        (entry.description && !entry.qty) ||
        (!entry.description && entry.qty)
      ) {
        isValid = false;
      }
    });

    return isValid;
  };

  const { loading } = useQuery(DVR_REPORT_BY_ID, {
    variables: { id: editId },
    onCompleted: (completedData) => {
      const currentDeficiency =
        completedData?.dealer_dvr_report_by_pk?.current_deficiency;
      const advertising_campaign =
        completedData.dealer_dvr_report_by_pk?.advertising_campaign;

      const updatedData = {
        ...completedData?.dealer_dvr_report_by_pk,
        current_deficiency:
          currentDeficiency === true
            ? "yes"
            : currentDeficiency === false
            ? "no"
            : null,
        advertising_campaign:
          advertising_campaign === true
            ? "yes"
            : advertising_campaign === false
            ? "no"
            : null,
      };
      setValues(updatedData);
      setComment(
        completedData?.dealer_dvr_report_by_pk?.dvr_comments?.find(
          (e) => e?.profile?.profile_id === auth.getSub()
        )?.comment
      );
      setCommentId(
        completedData?.dealer_dvr_report_by_pk?.dvr_comments?.find(
          (e) => e?.profile?.profile_id === auth.getSub()
        )?.id
      );
      if (
        completedData?.dealer_dvr_report_by_pk?.dvr_other_brands?.length > 0
      ) {
        setReportEntries(
          completedData?.dealer_dvr_report_by_pk?.dvr_other_brands
        );
      }
      if (completedData?.dealer_dvr_report_by_pk?.dvr_our_brands?.length > 0) {
        setBrandEntries(completedData?.dealer_dvr_report_by_pk?.dvr_our_brands);
      }
    },
    skip: !editId,
  });

  return (
    <>
      {loading || profileLoading ? (
        <CircularProgress />
      ) : (
        <Mutation
          mutation={editId ? UPDATE_DVR_REPORT : ADD_DEALER_DVR_REPORT}
          onCompleted={completedAdd}
        >
          {(addDealerDvrReport, { data, loading, called, error }) => {
            if (error) toast.error(error?.graphQLErrors?.[0]?.message);
            return (
              <Mutation
                mutation={ADD_DVR_OTHER_BRAND}
                onError={() => setIsSubmit(false)}
              >
                {(addOtherBrand, { data, loading, called, error }) => {
                  if (error) toast.error(error?.graphQLErrors?.[0]?.message);
                  return (
                    <Mutation
                      mutation={ADD_DVR_OUR_BRAND}
                      onError={() => setIsSubmit(false)}
                    >
                      {(addOurBrand, { data, loading, called, error }) => {
                        if (error)
                          toast.error(error?.graphQLErrors?.[0]?.message);
                        return (
                          <Mutation
                            mutation={DELETE_DVR_OTHER_BRAND}
                            onError={() => setIsSubmit(false)}
                          >
                            {(
                              deleteOtherBrand,
                              { data, loading, called, error }
                            ) => {
                              if (error)
                                toast.error(error?.graphQLErrors?.[0]?.message);
                              return (
                                <Mutation
                                  mutation={DELETE_DVR_OUR_BRAND}
                                  onError={() => setIsSubmit(false)}
                                >
                                  {(
                                    deleteOurBrand,
                                    { data, loading, called, error }
                                  ) => {
                                    if (error)
                                      toast.error(
                                        error?.graphQLErrors?.[0]?.message
                                      );
                                    return (
                                      <Mutation
                                        mutation={ADD_DVR_COMMENT}
                                        onError={() => setIsSubmit(false)}
                                      >
                                        {(
                                          addComment,
                                          { data, loading, called, error }
                                        ) => {
                                          if (error)
                                            toast.error(
                                              error?.graphQLErrors?.[0]?.message
                                            );
                                          return (
                                            <Mutation
                                              mutation={UPDATE_DVR_COMMENT}
                                              onError={() => setIsSubmit(false)}
                                            >
                                              {(
                                                updateComment,
                                                { data, loading, called, error }
                                              ) => {
                                                if (error) {
                                                  toast.error(
                                                    error?.graphQLErrors?.[0]
                                                      ?.message
                                                  );
                                                }

                                                return (
                                                  <form
                                                    className="form-container"
                                                    autoComplete="off"
                                                    onSubmit={(e) => {
                                                      e.preventDefault();
                                                      if (
                                                        validateEntries() &&
                                                        !errors
                                                      ) {
                                                        setIsSubmit(true);
                                                        values.profile_id =
                                                          auth.getSub();
                                                        values.current_deficiency =
                                                          values?.current_deficiency ===
                                                          "yes"
                                                            ? true
                                                            : values?.current_deficiency ===
                                                              "no"
                                                            ? false
                                                            : null;
                                                        values.advertising_campaign =
                                                          values?.advertising_campaign ===
                                                          "yes"
                                                            ? true
                                                            : values?.advertising_campaign ===
                                                              "no"
                                                            ? false
                                                            : null;

                                                        if (editId) {
                                                          delete values?.dvr_other_brands;
                                                          delete values?.dvr_our_brands;
                                                          delete values?.profile;
                                                          delete values?.profiles;
                                                          delete values.__typename;
                                                          delete values?.created_at;
                                                          delete values?.profile_id;
                                                          delete values?.comments;
                                                          delete values?.dvr_comments;
                                                          deleteOtherBrand({
                                                            variables: {
                                                              dealer_dvr_report_id:
                                                                values?.id,
                                                            },
                                                          });
                                                          deleteOurBrand({
                                                            variables: {
                                                              dealer_dvr_report_id:
                                                                values?.id,
                                                            },
                                                          });
                                                          addDealerDvrReport({
                                                            variables: values,
                                                          }).then((res) => {
                                                            const updatedReportEntries =
                                                              reportEntries.map(
                                                                (entry) => {
                                                                  delete entry?.__typename;
                                                                  return {
                                                                    ...entry,
                                                                    dealer_dvr_report_id:
                                                                      values?.id,
                                                                  };
                                                                }
                                                              );
                                                            const brandReportEntries =
                                                              brandEntries.map(
                                                                (entry) => {
                                                                  delete entry?.__typename;
                                                                  return {
                                                                    ...entry,
                                                                    dealer_dvr_report_id:
                                                                      values?.id,
                                                                  };
                                                                }
                                                              );
                                                            if (
                                                              updatedReportEntries?.[0]
                                                                ?.description
                                                            ) {
                                                              addOtherBrand({
                                                                variables: {
                                                                  objects:
                                                                    updatedReportEntries,
                                                                },
                                                              }).then((res) => {
                                                                resetState();
                                                                setValues({});
                                                                setReportEntries(
                                                                  [
                                                                    {
                                                                      dealer_dvr_report_id:
                                                                        "",
                                                                      description:
                                                                        "",
                                                                      qty: "",
                                                                    },
                                                                  ]
                                                                );
                                                              });
                                                            }
                                                            if (comment) {
                                                              updateComment({
                                                                variables: {
                                                                  id: commentId,
                                                                  comment:
                                                                    comment,
                                                                },
                                                              }).catch(
                                                                (err) => {
                                                                  toast.error(
                                                                    err.toString()
                                                                  );
                                                                }
                                                              );
                                                            }
                                                            if (
                                                              brandReportEntries?.[0]
                                                                ?.description
                                                            ) {
                                                              addOurBrand({
                                                                variables: {
                                                                  objects:
                                                                    brandReportEntries,
                                                                },
                                                              }).then((res) => {
                                                                resetState();
                                                                setValues({});
                                                                setBrandEntries(
                                                                  [
                                                                    {
                                                                      dealer_dvr_report_id:
                                                                        "",
                                                                      description:
                                                                        "",
                                                                      qty: "",
                                                                    },
                                                                  ]
                                                                );
                                                              });
                                                            }
                                                          });
                                                        } else {
                                                          const add_dealer_dvr_data =
                                                            {
                                                              ...values,
                                                              profile_id:
                                                                auth.getSub(),
                                                            };

                                                          addDealerDvrReport({
                                                            variables: {
                                                              objects: [
                                                                add_dealer_dvr_data,
                                                              ],
                                                            },
                                                          }).then((res) => {
                                                            const dvr_id =
                                                              res?.data
                                                                ?.insert_dealer_dvr_report
                                                                ?.returning?.[0]
                                                                ?.id;
                                                            const updatedReportEntries =
                                                              reportEntries.map(
                                                                (entry) => ({
                                                                  ...entry,
                                                                  dealer_dvr_report_id:
                                                                    dvr_id,
                                                                })
                                                              );
                                                            const brandReportEntries =
                                                              brandEntries.map(
                                                                (entry) => ({
                                                                  ...entry,
                                                                  dealer_dvr_report_id:
                                                                    dvr_id,
                                                                })
                                                              );
                                                            if (comment) {
                                                              addComment({
                                                                variables: {
                                                                  objects: {
                                                                    comment:
                                                                      comment,
                                                                    profile_id:
                                                                      auth.getSub(),
                                                                    dvr_id:
                                                                      dvr_id,
                                                                  },
                                                                },
                                                              });
                                                            }
                                                            if (
                                                              updatedReportEntries?.[0]
                                                                ?.description
                                                            ) {
                                                              addOtherBrand({
                                                                variables: {
                                                                  objects:
                                                                    updatedReportEntries,
                                                                },
                                                              }).then((res) => {
                                                                resetState();
                                                                setValues({});
                                                                setReportEntries(
                                                                  [
                                                                    {
                                                                      dealer_dvr_report_id:
                                                                        "",
                                                                      description:
                                                                        "",
                                                                      qty: "",
                                                                    },
                                                                  ]
                                                                );
                                                              });
                                                            }
                                                            if (
                                                              brandReportEntries?.[0]
                                                                ?.description
                                                            ) {
                                                              addOurBrand({
                                                                variables: {
                                                                  objects:
                                                                    brandReportEntries,
                                                                },
                                                              }).then((res) => {
                                                                resetState();
                                                                setValues({});
                                                                setBrandEntries(
                                                                  [
                                                                    {
                                                                      dealer_dvr_report_id:
                                                                        "",
                                                                      description:
                                                                        "",
                                                                      qty: "",
                                                                    },
                                                                  ]
                                                                );
                                                              });
                                                            }
                                                          });
                                                        }
                                                        return false;
                                                      } else {
                                                        toast.error(
                                                          "Description or Qty is required for each entry."
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <div className="main_dev_rep_section">
                                                      <div className="header_section">
                                                        NEW DEALER DVR REPORT
                                                      </div>
                                                      <div className="middle_section">
                                                        <ul className="contact_info">
                                                          <li>
                                                            <p className="label">
                                                              CAROLINA SKIFF :
                                                            </p>
                                                            <p>
                                                              {" "}
                                                              3231 Fulford Road
                                                              Waycross Georgia{" "}
                                                            </p>
                                                          </li>
                                                          <li>
                                                            <p className="label">
                                                              PHONE :
                                                            </p>
                                                            <p>
                                                              {" "}
                                                              912-287-0547F{" "}
                                                            </p>
                                                          </li>
                                                          <li>
                                                            <p className="label">
                                                              FAX :
                                                            </p>
                                                            <p>
                                                              {" "}
                                                              912-287-0533{" "}
                                                            </p>
                                                          </li>
                                                        </ul>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              id="date"
                                                              label="Date"
                                                              name="date"
                                                              type="date"
                                                              variant="outlined"
                                                              value={
                                                                values?.date ||
                                                                " "
                                                              }
                                                              onChange={
                                                                handleChange
                                                              }
                                                              className="Texfield_input dateInput"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            xs={0}
                                                            sm={0}
                                                            md={4}
                                                          ></Grid>
                                                          <Grid
                                                            xs={0}
                                                            sm={0}
                                                            md={4}
                                                          ></Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              name="dealership"
                                                              label="Select Dealer"
                                                              variant="outlined"
                                                              select
                                                              // className={classes.textField}
                                                              value={
                                                                values?.dealership ||
                                                                ""
                                                              }
                                                              onChange={
                                                                handleChange
                                                              }
                                                              SelectProps={{
                                                                native: true,
                                                                MenuProps: {
                                                                  // className: classes.menu,
                                                                },
                                                              }}
                                                            >
                                                              <option value=""></option>
                                                              {profileData?.sales_assign &&
                                                                profileData?.sales_assign.map(
                                                                  (option) => (
                                                                    <option
                                                                      key={
                                                                        option
                                                                          ?.assign_profiles
                                                                          ?.profile_id
                                                                      }
                                                                      value={
                                                                        option
                                                                          ?.assign_profiles
                                                                          ?.profile_id
                                                                      }
                                                                    >
                                                                      {
                                                                        option
                                                                          ?.assign_profiles
                                                                          ?.name
                                                                      }
                                                                      {option
                                                                        ?.assign_profiles
                                                                        ?.status ===
                                                                      "archived"
                                                                        ? " - Archived"
                                                                        : ""}
                                                                    </option>
                                                                  )
                                                                )}
                                                            </TextField>
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="contact_name"
                                                              name="contact_name"
                                                              label="Contact Name"
                                                              value={
                                                                values?.contact_name ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              variant="outlined"
                                                              className="Texfield_input"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="phone"
                                                              name="phone"
                                                              label="Phone"
                                                              value={
                                                                values?.phone ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "phone"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="fax"
                                                              name="fax"
                                                              label="Fax"
                                                              value={
                                                                values?.fax ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="address"
                                                              name="address"
                                                              label="Address"
                                                              value={
                                                                values?.address ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              id="address_2"
                                                              name="address_2"
                                                              label="Address Line 2 (Suites, Apt. # etc.)"
                                                              value={
                                                                values?.address_2 ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              variant="outlined"
                                                              className="Texfield_input"
                                                            />
                                                          </Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="bta"
                                                              name="bta"
                                                              label="BTA"
                                                              value={
                                                                values?.bta ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="program"
                                                              name="program"
                                                              label="Program"
                                                              value={
                                                                values?.program ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <TextField
                                                              required
                                                              id="sales_goal"
                                                              name="sales_goal"
                                                              label="Sales Goal"
                                                              value={
                                                                values?.sales_goal ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                Wholesale:
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                {" "}
                                                                <TextField
                                                                  id="whole_sale_units"
                                                                  name="whole_sale_units"
                                                                  label="Units"
                                                                  type="number"
                                                                  value={
                                                                    values?.whole_sale_units ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  className="Texfield_input"
                                                                  variant="outlined"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                <TextField
                                                                  id="whole_sale_dollars"
                                                                  name="whole_sale_dollars"
                                                                  label="Dollars"
                                                                  value={
                                                                    values?.whole_sale_dollars ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  variant="outlined"
                                                                  className="Texfield_input"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                Retail:
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                <TextField
                                                                  id="retail_units"
                                                                  name="retail_units"
                                                                  label="Units"
                                                                  value={
                                                                    values?.retail_units ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  className="Texfield_input"
                                                                  variant="outlined"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                <TextField
                                                                  id="retail_dollars"
                                                                  name="retail_dollars"
                                                                  label="Dollars"
                                                                  value={
                                                                    values?.retail_dollars ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  variant="outlined"
                                                                  className="Texfield_input"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                On Order:
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                <TextField
                                                                  id="on_order_units"
                                                                  name="on_order_units"
                                                                  label="Units"
                                                                  value={
                                                                    values?.on_order_units ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  className="Texfield_input"
                                                                  variant="outlined"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={4}
                                                                sm={4}
                                                                md={4}
                                                              >
                                                                <TextField
                                                                  id="on_order_dollars"
                                                                  name="on_order_dollars"
                                                                  label="Dollars"
                                                                  value={
                                                                    values?.on_order_dollars ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  variant="outlined"
                                                                  className="Texfield_input"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              Average Market
                                                              Share
                                                            </p>
                                                            <TextField
                                                              id="average_market_share"
                                                              name="average_market_share"
                                                              value={
                                                                values?.average_market_share ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                              type="number"
                                                              inputProps={{
                                                                "aria-label":
                                                                  "weight",
                                                                pattern:
                                                                  "\\d*\\.?\\d+",
                                                                min: "0",
                                                              }}
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              B. T. A Current
                                                              Market Share
                                                            </p>
                                                            <TextField
                                                              id="bta_current_market_share"
                                                              name="bta_current_market_share"
                                                              label=""
                                                              value={
                                                                values?.bta_current_market_share ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                              type="number"
                                                              inputProps={{
                                                                "aria-label":
                                                                  "weight",
                                                                pattern:
                                                                  "\\d*\\.?\\d+",
                                                                min: "0",
                                                              }}
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              Is There a Current
                                                              Deficiency
                                                            </p>
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={6}
                                                                sm={6}
                                                                md={4}
                                                              >
                                                                <FormControl component="fieldset">
                                                                  <RadioGroup
                                                                    aria-label="current_deficiency"
                                                                    name="current_deficiency"
                                                                    value={
                                                                      values.current_deficiency ||
                                                                      ""
                                                                    }
                                                                    onChange={
                                                                      handleChange
                                                                    }
                                                                  >
                                                                    <FormControlLabel
                                                                      value={
                                                                        "yes"
                                                                      }
                                                                      control={
                                                                        <Radio />
                                                                      }
                                                                      label="YES"
                                                                    />
                                                                  </RadioGroup>
                                                                </FormControl>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={6}
                                                                sm={6}
                                                                md={4}
                                                              >
                                                                <FormControl component="fieldset">
                                                                  <RadioGroup
                                                                    aria-label="current_deficiency"
                                                                    name="current_deficiency"
                                                                    value={
                                                                      values.current_deficiency ||
                                                                      ""
                                                                    }
                                                                    onChange={
                                                                      handleChange
                                                                    }
                                                                  >
                                                                    <FormControlLabel
                                                                      value={
                                                                        "no"
                                                                      }
                                                                      control={
                                                                        <Radio />
                                                                      }
                                                                      label="NO"
                                                                    />
                                                                  </RadioGroup>
                                                                </FormControl>
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              # Units to Correct
                                                              Deficiency
                                                            </p>
                                                            <TextField
                                                              id="correct_deficiency"
                                                              name="correct_deficiency"
                                                              label=" "
                                                              value={
                                                                values?.correct_deficiency ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChange(
                                                                  e,
                                                                  "text"
                                                                )
                                                              }
                                                              className="Texfield_input"
                                                              variant="outlined"
                                                            />
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              Number Of Boats
                                                              Displayed
                                                            </p>
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={3}
                                                                sm={3}
                                                                md={3}
                                                              >
                                                                Carolina Skiff
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={3}
                                                                sm={3}
                                                                md={3}
                                                              >
                                                                <TextField
                                                                  id="carolina_no_of_boats"
                                                                  name="carolina_no_of_boats"
                                                                  label=" "
                                                                  value={
                                                                    values?.carolina_no_of_boats ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  className="Texfield_input"
                                                                  variant="outlined"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={3}
                                                                sm={3}
                                                                md={3}
                                                              >
                                                                Sea Chaser
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={3}
                                                                sm={3}
                                                                md={3}
                                                              >
                                                                <TextField
                                                                  id="sea_chaser_no_of_boats"
                                                                  name="sea_chaser_no_of_boats"
                                                                  label=" "
                                                                  value={
                                                                    values?.sea_chaser_no_of_boats ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleChange(
                                                                      e,
                                                                      "text"
                                                                    )
                                                                  }
                                                                  className="Texfield_input"
                                                                  variant="outlined"
                                                                  type="number"
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "weight",
                                                                    pattern:
                                                                      "\\d*\\.?\\d+",
                                                                    min: "0",
                                                                  }}
                                                                />
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                          >
                                                            <p className="label_text">
                                                              Does Dealer have a
                                                              marketing/advertising
                                                              campaign ?
                                                            </p>
                                                            <Grid
                                                              container
                                                              direction="row"
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={6}
                                                                sm={6}
                                                                md={4}
                                                              >
                                                                <RadioGroup
                                                                  aria-label="advertising_campaign"
                                                                  name="advertising_campaign"
                                                                  value={
                                                                    values.advertising_campaign ||
                                                                    ""
                                                                  }
                                                                  onChange={
                                                                    handleChange
                                                                  }
                                                                >
                                                                  <FormControlLabel
                                                                    value={
                                                                      "yes"
                                                                    }
                                                                    control={
                                                                      <Radio />
                                                                    }
                                                                    label="YES"
                                                                  />
                                                                </RadioGroup>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={6}
                                                                sm={6}
                                                                md={4}
                                                              >
                                                                <RadioGroup
                                                                  aria-label="advertising_campaign"
                                                                  name="advertising_campaign"
                                                                  value={
                                                                    values.advertising_campaign ||
                                                                    ""
                                                                  }
                                                                  onChange={
                                                                    handleChange
                                                                  }
                                                                >
                                                                  <FormControlLabel
                                                                    value={"no"}
                                                                    control={
                                                                      <Radio />
                                                                    }
                                                                    label="NO"
                                                                  />
                                                                </RadioGroup>
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                        </Grid>
                                                        <Grid
                                                          container
                                                          spacing={4}
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={6}
                                                          >
                                                            <Grid
                                                              container
                                                              spacing={2}
                                                            >
                                                              <Grid
                                                                item
                                                                xs={9}
                                                                sm={9}
                                                                md={9}
                                                              >
                                                                <p className="label_text">
                                                                  Other Boat
                                                                  Brands
                                                                  Displayed
                                                                </p>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={3}
                                                                sm={3}
                                                                md={3}
                                                              >
                                                                <p className="label_text">
                                                                  Qty
                                                                </p>
                                                              </Grid>
                                                            </Grid>
                                                            {reportEntries.map(
                                                              (
                                                                brand,
                                                                index
                                                              ) => (
                                                                <Grid
                                                                  item
                                                                  xs={12}
                                                                  key={index}
                                                                >
                                                                  <Grid
                                                                    container
                                                                    spacing={2}
                                                                  >
                                                                    <Grid
                                                                      item
                                                                      xs={9}
                                                                      sm={9}
                                                                      md={9}
                                                                    >
                                                                      <TextField
                                                                        id={`brand1_${brand.id}`}
                                                                        name={`brand1_${brand.id}`}
                                                                        label=" "
                                                                        value={
                                                                          brand?.description ||
                                                                          ""
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handleReportEntryChange(
                                                                            index,
                                                                            "description",
                                                                            e
                                                                              .target
                                                                              .value
                                                                          )
                                                                        }
                                                                        className="Texfield_input"
                                                                        variant="outlined"
                                                                      />
                                                                    </Grid>
                                                                    <Grid
                                                                      item
                                                                      xs={3}
                                                                      sm={3}
                                                                      md={3}
                                                                    >
                                                                      <TextField
                                                                        id={`qty_${brand.id}`}
                                                                        name={`qty_${brand.id}`}
                                                                        value={
                                                                          brand?.qty ||
                                                                          ""
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handleReportEntryChange(
                                                                            index,
                                                                            "qty",
                                                                            e
                                                                              .target
                                                                              .value
                                                                          )
                                                                        }
                                                                        label=" "
                                                                        className="Texfield_input"
                                                                        variant="outlined"
                                                                        type="number"
                                                                        inputProps={{
                                                                          "aria-label":
                                                                            "weight",
                                                                          pattern:
                                                                            "\\d*\\.?\\d+",
                                                                          min: "0",
                                                                        }}
                                                                      />
                                                                    </Grid>
                                                                  </Grid>
                                                                </Grid>
                                                              )
                                                            )}
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              onClick={
                                                                addReportEntry
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginTop:
                                                                  "10px",
                                                              }}
                                                            >
                                                              + Add More
                                                            </Grid>
                                                          </Grid>
                                                          {brandEntries.length >
                                                            0 && (
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              sm={6}
                                                              md={6}
                                                            >
                                                              <Grid
                                                                container
                                                                spacing={2}
                                                              >
                                                                <Grid
                                                                  item
                                                                  xs={9}
                                                                  sm={9}
                                                                  md={9}
                                                                >
                                                                  <p className="label_text">
                                                                    Our Brands
                                                                    Currently In
                                                                    Stock
                                                                  </p>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  xs={3}
                                                                  sm={3}
                                                                  md={3}
                                                                >
                                                                  <p className="label_text">
                                                                    Qty
                                                                  </p>
                                                                </Grid>
                                                              </Grid>
                                                              {brandEntries.map(
                                                                (
                                                                  brand,
                                                                  index
                                                                ) => (
                                                                  <Grid
                                                                    item
                                                                    xs={12}
                                                                    key={index}
                                                                  >
                                                                    <Grid
                                                                      container
                                                                      spacing={
                                                                        2
                                                                      }
                                                                    >
                                                                      <Grid
                                                                        item
                                                                        xs={9}
                                                                        sm={9}
                                                                        md={9}
                                                                      >
                                                                        <TextField
                                                                          id={`brand2_${brand.id}`}
                                                                          name={`brand2_${brand.id}`}
                                                                          label=" "
                                                                          value={
                                                                            brand?.description ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handleBrandChange(
                                                                              index,
                                                                              "description",
                                                                              e
                                                                                .target
                                                                                .value
                                                                            )
                                                                          }
                                                                          className="Texfield_input"
                                                                          variant="outlined"
                                                                        />
                                                                      </Grid>
                                                                      <Grid
                                                                        item
                                                                        xs={3}
                                                                        sm={3}
                                                                        md={3}
                                                                      >
                                                                        <TextField
                                                                          id={`qty2_${brand.id}`}
                                                                          name={`qty2_${brand.id}`}
                                                                          value={
                                                                            brand?.qty ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handleBrandChange(
                                                                              index,
                                                                              "qty",
                                                                              e
                                                                                .target
                                                                                .value
                                                                            )
                                                                          }
                                                                          label=" "
                                                                          className="Texfield_input"
                                                                          variant="outlined"
                                                                          type="number"
                                                                          inputProps={{
                                                                            "aria-label":
                                                                              "weight",
                                                                            pattern:
                                                                              "\\d*\\.?\\d+",
                                                                            min: "0",
                                                                          }}
                                                                        />
                                                                      </Grid>
                                                                    </Grid>
                                                                  </Grid>
                                                                )
                                                              )}
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                onClick={
                                                                  addBrandEntry
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  marginTop:
                                                                    "10px",
                                                                }}
                                                              >
                                                                + Add More
                                                              </Grid>
                                                            </Grid>
                                                          )}
                                                        </Grid>
                                                        <div>
                                                          <Grid container>
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              sm={12}
                                                              md={12}
                                                            >
                                                              <p class="label_text">
                                                                Comments
                                                              </p>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              sm={12}
                                                              md={12}
                                                            >
                                                              <TextField
                                                                id="comments"
                                                                name="comments"
                                                                label="Add Comment Here"
                                                                multiline
                                                                rows="4"
                                                                variant="outlined"
                                                                onChange={(e) =>
                                                                  handleChanges(
                                                                    e
                                                                  )
                                                                }
                                                                margin="normal"
                                                                value={
                                                                  comment || ""
                                                                }
                                                                error={errors}
                                                                helperText={
                                                                  errors
                                                                    ? "Maximum 700 words allowed"
                                                                    : ""
                                                                }
                                                                style={{
                                                                  width: "100%",
                                                                  marginTop:
                                                                    "0px",
                                                                }}
                                                              />
                                                            </Grid>
                                                            <Typography
                                                              variant="body2"
                                                              color="error"
                                                            >
                                                              {errors &&
                                                                "Maximum 700 words"}
                                                            </Typography>
                                                          </Grid>
                                                        </div>
                                                        <div className="button_wrap ">
                                                          <Button
                                                            type="submit"
                                                            className="save_btn"
                                                            disabled={isSubmit}
                                                          >
                                                            Save
                                                          </Button>
                                                          <Button
                                                            color="secondary"
                                                            variant="contained"
                                                            className="cancel_btn"
                                                            // className={classes.Button}
                                                            onClick={() =>
                                                              history.push(
                                                                "/dealer-dvr-report"
                                                              )
                                                            }
                                                            // style={{
                                                            //   width: "120px",
                                                            //   margin: "2em 1em",
                                                            // }}
                                                          >
                                                            Cancel
                                                          </Button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </form>
                                                );
                                              }}
                                            </Mutation>
                                          );
                                        }}
                                      </Mutation>
                                    );
                                  }}
                                </Mutation>
                              );
                            }}
                          </Mutation>
                        );
                      }}
                    </Mutation>
                  );
                }}
              </Mutation>
            );
          }}
        </Mutation>
      )}
    </>
  );
}
export default withRouter(AddDvrReport);
